import React, { Component } from "react";
import WaitingModal from "./generics/WaitingModal";
import { translate } from "react-i18next";
import swal from 'sweetalert';
import { logout,getUserGeneric } from "../libs/services";
import { Auth } from "aws-amplify";

var Config = require('../config');
class ChangedPasswordExpired extends Component{
    constructor(props){
        super(props)
		this.changePass = this.changePass.bind(this);
		this.state={
			expiration_password_date:"",
			old_pwd:"",
			new_pwd:"",
			c_pwd:"",
			expiration_day:{},
			isAuthenticated:false,
		}
    }
    componentDidMount(){
        //this.props.onRef(this);
    }
	componentWillUnmount() {
		//this.props.onRef(null)
	
	  }
	  handleChange(e){
		this.setState({
		  [e.target.name]: e.target.value
		});
	}
	changePass(){
		if(this.state.new_pwd.localeCompare(this.state.c_pwd) !== -1){
			document.getElementById('new_pwd').classList.remove('error');
			document.getElementById('c_pwd').classList.remove('error');
			var password = btoa(this.state.old_pwd);
			password = password.split("").reverse().join("");

			if(this.isValidForm()){
				this.waiting_modal.handleShow('Cambiando...');
				fetch(Config.default.apiGateway.URL+'users/change_password?old_pwd='+password+
					'&new_pwd='+this.state.new_pwd,{
					method: 'POST',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Success', 'Contraseña Actualizada Correctamente, Inicia sesión de nuevo', 'success');
						//this.handleClose();
						this.handleLogout();
						//this.setState({passwordExpired:false})
						//window.location.reload();
						//this.props.history.push("/");
						//window.location.reload();
					}
				})
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			document.getElementById('new_pwd').classList.add('error');
			document.getElementById('c_pwd').classList.add('error');
			swal('Error', 'Las Contraseñas deben coincidir', 'error');
		}
			
			
	}
	isValidForm() {
	    const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}
	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}
	async handleLogout(event){
		await logout();
		
		if(sessionStorage.getItem("generic_session_id") !== null){
			var generic = await getUserGeneric();
			if(generic !== undefined){
				sessionStorage.setItem("token", ""); 
				this.userHasAuthenticated(false);
				this.props.history.push("/login");
			}
			
		}else{
			await Auth.signOut();
			localStorage.clear();
			sessionStorage.clear();
			this.props.socket.close();
			this.userHasAuthenticated(false);
			this.props.history.push("/login");
			
		}	
	};
	userHasAuthenticated = authenticated => {
		this.setState({ isAuthenticated: authenticated });
	}
    render(){
        return(
            <div>
				<div className="row" style={{textAlign:"center"}}>
				<div className="col-xs-12 col-sm-10 col-md-offset-1">
					<h1>Actualizar Contraseña</h1>
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">
							{('contraseña actual')}
						</span>
					</div>
					<div className="col-xs-12 col-sm-8">
						<input className="col-xs-12 form-control"
							name="old_pwd" id="old_pwd"
							type="password"
							value={this.state.old_pwd}
							onChange={(e)=>this.handleChange(e)}
							required/>
					</div>
				</div>

				<div className="form-group col-xs-12">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">
							{('nueva contraseña')}
						</span>
					</div>
					<div className="col-xs-12 col-sm-8">
						<input className="col-xs-12 form-control"
							name="new_pwd" id="new_pwd"
							type="password"
							value={this.state.new_pwd}
							onChange={(e)=>this.handleChange(e)}
							required/>
					</div>
				</div>

				<div className="form-group col-xs-12">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">
							{('confirmar contraseña')}
						</span>
					</div>
					<div className="col-xs-12 col-sm-8">
						<input className="col-xs-12 form-control"
							name="c_pwd" id="c_pwd"
							type="password"
							value={this.state.c_pwd}
							onChange={(e)=>this.handleChange(e)}
							required/>
					</div>
				</div>				
			</div>
			<div className="col-xs-12">
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<button type="button" className="btn btn-primary"  onClick={this.changePass}>Guardar</button>
		        	</div>
				</div>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		</div>
        </div>
        );
    }
}
export default translate('translations')(ChangedPasswordExpired)